// extracted by mini-css-extract-plugin
module.exports = {"contacts":"contacts_contacts__Pqsy2"};